import React from 'react';
import { withRouter } from 'react-router-dom';

import Zones from './Zones';
import render from './render';

export class UsersManagement extends React.Component {
  static defaultProps = {
    render,
  };

  addUser = () => {
    const { history: { push }, match: { path } } = this.props;
    push(`${path}/new`);
  }

  goBack = () => {
    const { history: { push }, match: { path } } = this.props;
    push(path);
  }

  render () {
    const { render: Render, ...nextProps } = this.props;
    const { addUser, goBack } = this;
    const props = {
      ...nextProps,
      addUser,
      goBack,
    };

    return (
      <Zones>
        <Render {...props} />
      </Zones>
    );
  }
}

export default withRouter(UsersManagement);



// WEBPACK FOOTER //
// ./src/components/Admin/UsersManagement/index.js